import { useDispatch } from 'react-redux';
import { setIsComparisonBarClosed } from '@client/settings/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useSetIsProductsComparisonBarClosed = (): typeof setIsComparisonBarClosed => {
  const dispatch = useDispatch();

  return bindActionCreators(setIsComparisonBarClosed, dispatch);
};
